// extracted by mini-css-extract-plugin
export default {"companyContainer":"FK-z","companyImage":"GK-z","container":"HK-z","heading":"IK-z","darkText":"JK-z","smallHeading":"KK-z","darkBackground":"LK-z","whiteBackground":"MK-z"};